import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import MetricsNode from "./MetricsNode";

// 🔥 Firebase imports
import firebase from "firebase";
import { secondaryDb } from "../../../../utils/firebase/temp";
import {
  fetchCustomerInfoUsingLocationId,
  fetchDisplayInfo,
  getLayout,
} from "../../../../services/insightApp/metrics";
import { fetchAllFilterLocations } from "../../../../services/locationApp/locationFilterService";

/**
 * MetricsListPageNewNew Component
 *
 * This component fetches and displays real-time metrics from Firebase
 * based on the selected locationId and updates automatically on DB changes.
 */
const MetricsListPageNewNew: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [clientId, setClientId] = useState("");
  const [stationNode, setStationNode] = useState<any>({});
  const [layoutDetails, setLayoutDetails] = useState<any>({});
  const [locationSelectorList, setLocationSelectorList] = useState<any>([]);

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const getCustomerInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await fetchCustomerInfoUsingLocationId(locationId);
      if (res?.data?.data?.clientId) {
        const clientIdFromApi = res.data.data.clientId;
        setClientId(clientIdFromApi);
      }
    } catch (error) {
      setError("Please try again later.");
    }
  };

  useEffect(() => {
    document.title = "Insight - Dashboard";

    getCustomerInfo();
  }, [locationId]);

  const getAllFilterLocation = async () => {
    fetchAllFilterLocations("")
      .then((res) => {
        let locationList: any = [];
        /* Setting up the list of locations as needed to select locations. */
        if (!_.isEmpty(res.data.data)) {
          res.data.data.map((location: any) => {
            locationList.push({
              id: location.id,
              label: location.businessDisplayName,
            });
          });
        }
        setLocationSelectorList(locationList);
        setIsLoading(false);
      })
      .catch(() => {
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      });
  };

  const getLayoutInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await getLayout(locationId);
      setLayoutDetails(res.data.data);
      getAllFilterLocation();
      //   if (res?.data?.data?.clientId) {
      //     const clientIdFromApi = res.data.data.clientId;
      //     setClientId(clientIdFromApi);
      //   }
    } catch (error) {}
  };

  const getStationInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await fetchDisplayInfo(locationId);
      setStationNode(res.data.data);
      getLayoutInfo();
      //   if (res?.data?.data?.clientId) {
      //     const clientIdFromApi = res.data.data.clientId;
      //     setClientId(clientIdFromApi);
      //   }
    } catch (error) {}
  };

  useEffect(() => {
    getStationInfo();
  }, []);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <MetricsNode
          stationNode={stationNode}
          layoutDetails={layoutDetails}
          setLayoutDetails={setLayoutDetails}
          isLoading={isLoading}
          clientId={clientId}
          locationSelectorList={locationSelectorList}
          // locationMetricsNode={locationMetricsNode}
          // stationMetricsNode={stationMetricsNode}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(
  MetricsListPageNewNew,
  Authorities.CUSTOMER_LIST_READ,
);
